import {Component, inject, Signal, ViewChild} from '@angular/core';
import {MatDrawer} from '@angular/material/sidenav';
import {SanitizePipe} from '../../../shared/pipes/sanitize.pipe';
import {ReportsService} from '../../../services/reports.service';
import {toSignal} from '@angular/core/rxjs-interop';
import {GenReleaseNote} from '../../../generated/serverModels/GenReleaseNote';
import {DatePipe} from '@angular/common';
import {tap} from 'rxjs';

@Component({
  selector: 'tgrid-release-notes',
  imports: [
    SanitizePipe,
    DatePipe,
  ],
  templateUrl: './release-notes.component.html',
  standalone: true,
  styleUrl: './release-notes.component.scss',
})
export class ReleaseNotesComponent {

  // DOM Elements
  @ViewChild(MatDrawer) drawer: MatDrawer;

  private reportService = inject(ReportsService);
  protected activeNote: GenReleaseNote;
  protected releaseNotes: Signal<GenReleaseNote[]> = toSignal(this.reportService.getReleaseNotes().pipe(
    tap(notes => this.activeNote = notes[0]),
  ), {initialValue: []});


  setActiveNote(note: GenReleaseNote) {
    this.activeNote = note;
  }
}
